import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

const Box = styled.div`
  border: 0.5px solid #c4c4c4;
  ${tw`px-4 py-2 bg-white`};
  width: max-content;
  border-radius: 1px;

  & p {
    font-family: var(--formFontType, Circular Std) !important;
    font-size: var(--formFontSize, 12px);
    font-weight: 500;
    color: #ff6e5b;
  }
`;

const OutOfStock = ({ ctrlValidationError }) => (
  <Box className="error">
    <p>{ctrlValidationError}</p>
  </Box>
);

OutOfStock.defaultProps = {
  ctrlValidationError: null,
};

OutOfStock.propTypes = {
  ctrlValidationError: PropTypes.string,
};

export default OutOfStock;
